module.exports = __webpack_public_path__ + "static/media/0d6fa877-ea7b-490f-9f2b-3b31670813c9.35c18f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/0d6fa877-ea7b-490f-9f2b-3b31670813c9.png
// module id = 1480
// module chunks = 0